import { FC } from 'react';
import { Button, Paper, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
// import logoImg from '../../images/logo.svg';
import { useTranslation } from 'react-i18next';
import unknownError from '@/bo-kit/components/UnknownErrorPopup/images/unknownError.svg';
import { PageDialog } from '@/ui-kit/components';

const useStyles = makeStyles((theme: Theme) => ({
    btnControl: {
        height: theme.spacing(6),
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: '0.875rem',
        borderRadius: theme.spacing(1.25),
        textTransform: 'inherit',
    },
}));

export const DefaultUnknownErrorPopup: FC<{ onClose: () => void }> = ({ onClose }) => {
    const classes = useStyles();
    const { t } = useTranslation('payments');
    return (
        <PageDialog open onClose={onClose} closeVariant='cross'>
            {/* <img src={logoImg} alt='' /> */}
            <Paper
                elevation={3}
                square
                sx={({ spacing }) => ({
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    borderRadius: spacing(2),
                    pb: spacing(3.5),
                    mb: spacing(6),
                    mt: spacing(5),
                })}
            >
                <img
                    // for supporting both react and next apps
                    src={(unknownError as any).src ? (unknownError as any).src : unknownError}
                    alt={t('Payment error')}
                />
            </Paper>
            <Paper
                elevation={3}
                square
                sx={({ spacing }) => ({
                    width: '100%',
                    borderRadius: spacing(2),
                    p: spacing(3),
                })}
            >
                <Typography variant='h4' mb={3}>
                    {t('Ooops...')}
                </Typography>
                <Typography variant='body2' mb={2}>
                    {t('Something seems to gone wrong :(')}
                </Typography>

                <Typography variant='body2' mb={4}>
                    {t('Please try again later')}
                </Typography>
                <Button
                    className={classes.btnControl}
                    sx={({ spacing }) => ({
                        mb: spacing(1),
                    })}
                    variant='contained'
                    fullWidth
                    color='primary'
                    onClick={onClose}
                >
                    {t('Done')}
                </Button>
            </Paper>
        </PageDialog>
    );
};

export const LabelUnknownErrorPopup: FC<{ onClose: () => void }> = ({ onClose }) => {
    const classes = useStyles();
    const { t } = useTranslation('payments');
    return (
        <PageDialog open onClose={onClose} closeVariant='cross'>
            {/* <img src={`${process.env.PUBLIC_URL}/logo.svg`} height={32} alt='' /> */}
            <Paper
                elevation={3}
                square
                sx={({ spacing }) => ({
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    borderRadius: spacing(2),
                    pb: spacing(3.5),
                    mb: spacing(6),
                    mt: spacing(5),
                })}
            >
                <img
                    // for supporting both react and next apps
                    src={(unknownError as any).src ? (unknownError as any).src : unknownError}
                    alt={t('Payment error')}
                />
            </Paper>
            <Paper
                elevation={3}
                square
                sx={({ spacing }) => ({
                    width: '100%',
                    borderRadius: spacing(2),
                    p: spacing(3),
                })}
            >
                <Typography variant='h4' mb={3}>
                    {t('Ooops...')}
                </Typography>
                <Typography variant='body2' mb={2}>
                    {t('Something seems to gone wrong :(')}
                </Typography>

                <Typography variant='body2' mb={4}>
                    {t('Please try again later')}
                </Typography>
                <Button
                    className={classes.btnControl}
                    sx={({ spacing }) => ({
                        mb: spacing(1),
                    })}
                    variant='contained'
                    fullWidth
                    color='primary'
                    onClick={onClose}
                >
                    {t('Done')}
                </Button>
            </Paper>
        </PageDialog>
    );
};

// use different components for labeled and unlabeled apps during the build phase
// to maintain compatibility until all applications start using the new labeled components
export const UnknownErrorPopup = process.env.REACT_APP_LABEL_NAME
    ? LabelUnknownErrorPopup
    : DefaultUnknownErrorPopup;
